
import { Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
import ProductListCarouselCard from "~/components/common/ProductListCarouselCard.vue";
import UiScrollableSlider from "~/components/UI/UiScrollableSlider.vue";
import RelatedProductBlock from "~/components/blocks/RelatedProductBlock.vue";

export default {
  name: "CartRelatedProducts",
  components: {
    Swiper,
    SwiperSlide,
    ProductListCarouselCard,
    UiScrollableSlider,
    RelatedProductBlock,
  },
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) =>
        ["drawer-desktop", "drawer-mobile", "page"].includes(value),
    },
    shouldRender: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    statisticItemListName() {
      return this.getItemListName("Shopping Cart", this.title);
    },
    statisticItemListId() {
      return "cart";
    },
  },
  methods: {
    getItemListName(prefix, suffix) {
      return suffix ? `${prefix} - ${suffix}` : prefix;
    },
    handleProductAdded() {
      this.$emit("product-added");
    },
  },
};
